import styled from "@emotion/styled";

import { theme } from "../../../Controls/Internals/ThemeProvider/CandyTheme/ThemeShorthand";

import WarningIcon from "./Icons/Warning.svg";
import InfoIcon from "./Icons/Info.svg";

export const EmptyContainer = styled.div(_ => ({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    flexGrow: 1,
    minHeight: "100%",
}));

export const EmptyContainerInner = styled.div(_ => ({
    textAlign: "center",
}));

export const DocumentsContainer = styled.div(_ => ({
    display: "flex",
    flexDirection: "column",
    minHeight: "100%",
}));

export const DescriptionContainer = styled.div(() => ({
    marginBottom: "16px",
}));

export const IconContainer = styled.div(() => ({
    marginBottom: "24px",
}));

export const EmptyText = styled.div(props => ({
    color: theme(props).typography.secondary.color,
    fontSize: "16px",
}));

export const Warning = styled.div(props => ({
    position: "relative",
    borderRadius: "8px",
    backgroundColor: theme(props).semanticColors.warning.backgroundColor,
    padding: "8px 16px 8px 40px",
    marginBottom: "16px",
    boxSizing: "border-box",

    ":before": {
        content: '""',
        position: "absolute",
        top: "8px",
        left: "16px",
        width: "16px",
        height: "16px",
        backgroundImage: `url(${WarningIcon})`,
    },
}));

export const Hint = styled.div(props => ({
    position: "relative",
    borderRadius: "8px",
    backgroundColor: theme(props).keyPalette.panelBackgroundColor,
    padding: "8px 16px 8px 40px",

    ":before": {
        content: '""',
        position: "absolute",
        top: "10px",
        left: "16px",
        width: "14px",
        height: "14px",
        backgroundImage: `url(${InfoIcon})`,
    },
}));

export const Ul = styled.ul(() => ({
    listStyleType: "none",
    padding: 0,
}));
